module.exports = __webpack_public_path__ + "img/logo-18.f219479.jpg";